import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "8",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5BC2F4",
      d: "M9.18 4.7 6.055 7.823a.6.6 0 0 1-.43.176.62.62 0 0 1-.45-.176.6.6 0 0 1 0-.879l2.052-2.07H1.25a.617.617 0 0 1-.625-.625.63.63 0 0 1 .625-.625h5.977l-2.051-2.05a.6.6 0 0 1 0-.88.6.6 0 0 1 .879 0L9.18 3.82a.6.6 0 0 1 0 .88"
    }, null, -1)
  ])))
}
export default { render: render }